import { processSteps } from "@/content";
import Reveal from "@/components/np/Reveal";

export default function ProcessSteps({ compact = false }) {
  return (
    <ol
      className={compact ? "grid gap-4 sm:grid-cols-2" : "grid gap-4 sm:grid-cols-2 lg:grid-cols-5"}
      data-testid="process-steps"
    >
      {processSteps.map((s, i) => (
        <Reveal
          as="li"
          key={s.title}
          delay={i * 80}
          className={`relative rounded-3xl bg-white ring-1 ring-line ${compact ? "p-5" : "p-6"} ${compact && i === processSteps.length - 1 ? "sm:col-span-2" : ""}`}
        >
          <span className={`font-serif leading-none text-sage ${compact ? "text-4xl" : "text-5xl"}`}>
            {String(i + 1).padStart(2, "0")}
          </span>
          <h3 className="mt-4 text-lg font-semibold text-ink">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-muted">{s.text}</p>
        </Reveal>
      ))}
    </ol>
  );
}
